import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

function ProtectedRoute({ children, requireAdmin = true }) {
  const { user, isLoading, isAdmin } = useAuth();
  const location = useLocation();

  useEffect(() => {
    console.log('ProtectedRoute - user:', user);
    console.log('ProtectedRoute - isLoading:', isLoading);
    console.log('ProtectedRoute - isAdmin:', isAdmin);
    console.log('ProtectedRoute - location:', location.pathname);
  }, [user, isLoading, isAdmin, location]);

  if (isLoading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    // Redirect to the login page, but save the location they were trying to access
    console.log('ProtectedRoute - redirecting to login');
    return <Navigate to="/secure-portal-access" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    // If admin access is required but the user is not an admin
    console.log('ProtectedRoute - not admin, redirecting to home');
    return <Navigate to="/" replace />;
  }

  console.log('ProtectedRoute - rendering children');
  return children;
}

export default ProtectedRoute;